import { inject, Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class MapLoaderService {
  private apiLoaded = false;

  load(): Promise<void> {
    if (this.apiLoaded) return Promise.resolve();

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCXgCuCT_nuvyc2T2NR4oZwi9U-ItTFHhk&callback=initMap`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        this.apiLoaded = true;
        resolve();
      };
      script.onerror = (err) => reject(err);

      document.body.appendChild(script);
    });
  }
}